<button
  type="button"
  class="link-button"
  [disabled]="disabled()"
  (click)="onClick($event)"
  (keydown.enter)="$event.stopPropagation()"
  (keydown.space)="$event.stopPropagation()"
>
  <span class="label" [ngStyle]="labelStyles | theme">{{ label() }}</span>
  @let value = amount();
  @if (value) {
    <app-currency-amount [primaryAmount]="value" [amountStyles]="labelStyles" />
  }
  @if (arrow()) {
    <app-icon
      class="arrow"
      icon="arrow-right"
      colorCss="--button-wager-link-icon-fill"
      sizeCss="--icon-medium"
    />
  }
</button>
